import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import AiIndividual1 from '@parchment/ui-icons/lib/ai/individual-1';
import AiVerified from '@parchment/ui-icons/lib/ai/verified';
import AiDownload3 from '@parchment/ui-icons/lib/ai/download-3';
import AiWarning from '@parchment/ui-icons/lib/ai/warning';
import "../style/InstitutionPage.less";
import { Section, InputGrid, InputRow, InputField, ContinueButton, AddressGrid, NotificationBanner } from '@parchment/ui-primitives';
import { string as yupString, object as yupObject } from 'yup';
import validation from 'react-validation-mixin';
import strategy from 'yup-validation-strategy';
import _ from 'underscore';
import { countries } from '@parchment/ui-primitives';
import { autoComplete, validate } from '@parchment/ui-primitives/lib/utils/AddressValidation';
import LoginPage from '../containers/LoginContainer';
import { downloadBundledFile } from '../../common/utils/DownloadUtils';
import { getToken } from '../../common/utils/ApiUtils';

const ADDRESS_VERIFICATION_BASE_URL = window.config.service.addressVerificationApiUrl;
const RI_TYPES = [
    {value: 'RT_JC', label: 'Public 2 Year College'},
    {value: 'RT_JC_PR', label: 'Private 2 Year College'},
    {value: 'RT_UNIV', label: 'Public University/4 Year College'},
    {value: 'RT_UNIV_PR', label: 'Private University/4 Year College'},
    {value: 'RT_TECH', label: 'Technical College'},
    {value: 'RT_CAREER', label: 'Career College'},
    // {value: 'RT_NCAA', label: 'NCAA'},
    {value: 'RT_SCHOLARSHIP', label: 'Scholarship Fund'},
    {value: 'RT_APPSVC', label: 'Application Service'},
    {value: 'RT_CREDORG', label: 'Credentialing Organization'},
    {value: 'RT_EMPLYR', label: 'Employer'},
    {value: 'RT_HS', label: 'High School'},
    {value: 'RT_VERORG', label: 'Verification Organization'},
    {value: 'RT_GOV', label: 'Government'},
    {value: 'RT_MILITARY', label: 'Military'}
];

const noop = function () {};

class InstitutionPage extends Component {
    static get propTypes() {
        return Object.assign({}, super.propTypes, {
        });
    }

    static get defaultProps() {
        return Object.assign({}, super.defaultProps, {
            onValidate: noop
        });
    }

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.setFormValue = this.setFormValue.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.getValidatorData = this.getValidatorData.bind(this);
        this.toggleSignIn = this.toggleSignIn.bind(this);
        this.handleEnterForToggleSignIn = this.handleEnterForToggleSignIn.bind(this);
        this.validatorTypes = yupObject({
            firstName: yupString().required().label('First Name'),
            lastName: yupString().required().label('Last Name'),
            memberName: yupString().required().label('Organization / School Name'),
            riType: yupString().required().label('Organization Type'),
            title: yupString().required().label('Role / Title (ex. School Counselor)'),
            address1: yupString().required().label('Address Line 1'),
            city: yupString().required().label('City'),
            state: yupString().when('country', {
                is: (val) => {
                    const country = (_.findWhere(countries, { value: val }) || {});
                    return country.provinces && country.provinces.length > 0;
                },
                then: yupString().required()
            }).when('country', {
                is: 'US',
                then: yupString().label('State'),
                otherwise: yupString().label('Province')
            }),
            zip: yupString().required().label('Zip/Postal Code'),
            country: yupString().required().label('Country'),
            phone: yupString().when('country', {
                is: (country) =>  _.contains(['US', 'CA', 'MX'], country),
                then: yupString().test({
                    name: 'phone',
                    message: '${path} must be a valid phone number',
                    test: (val) => val.match(/^(?:\+?1[-. ]?)?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)
                })
            }),
            email: yupString().email().required(),
            retypeEmail: yupString().when('email', {
                is: (email) => email !== '',
                then: yupString().test({
                    name: 'verifyEmail',
                    message: '${path} is invalid',
                    test: function(value) {
                        return value === this.parent.email;
                    }
                })
            }),
            password: yupString().required(),
            retypePassword: yupString().when('password', {
                is: (password) => password !== '',
                then: yupString().test({
                    name: 'verifyPassword',
                    message: '${path} is invalid',
                    test: function(value) {
                        return value === this.parent.password;
                    }
                })
            })
        });
        const hash = window.location.hash || '#';
        if(hash.match(/\/login$/)) {
            window.location.hash = hash.replace(/\/login$/, '');
        }
        this.state = {
            ...this.getDefaultFormData(),
            showLogin: hash.match(/\/login$/) || window.location.pathname.match(/\/tpo\/login$/)
        };
    }

    componentWillMount() {
        // Do initial validation on data
        this.validatorTypes.isValid(this.state).then((isValid) => {
            this.setState({ isValid: isValid }, _.partial(this.props.onValidate, isValid));
        });
    }

    getValidatorData() {
        return this.state;
    }

    getDefaultFormData() {
        return Object.assign(
            {
                firstName: '',
                lastName: '',
                memberName: '',
                //industrySegment: '',
                riType: '',
                title: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zip: '',
                country: 'US',
                phone: '',
                email: '',
                password: '',
                isValid: false
            }
        );
    }

    setFormValue(name, value) {
        if(_.isString(name) && _.isString(value)) {
            const state = {error: null, isValid: true};
            state[name] = value === null ? '' : value;

            if (typeof state[name] === 'object' && typeof state[name].value === 'string') {
                this.setFormValue(name, value.value);
                return;
            }

            // If we are changing the country, then we must reset the state
            if (name === 'country' && this.state.country !== state[name]) {
                state.state = '';
            }

            this.setState(state, this.props.handleValidation(name));
        } else if(_.isObject(name) && _.isUndefined(value)) {
            this.setState(name);
        }
    }

    handleBlur(e) {
        this.props.handleValidation(e.target.name)();
    }

    onSubmit(e) {
        e.preventDefault();

        const member = {
            name: this.state.memberName,
            receiver: true,
            approvalMethod: 20,
            customerType: 'ST',
            deliveryMethod: 'electronic',
            pendingVerify: 'T',
            memberType: 'CO',
            riType: this.state.riType,
            paperStatus: 'none',
            openDestination: true,
            receiverStatus: 'TPO',
            address: {
                address1: this.state.address1,
                address2: this.state.address2,
                city: this.state.city,
                zoneName: this.state.state,
                countryName: this.state.country,
                postCode: this.state.zip
            },
            phone: this.state.phone,
            emailAddress: this.state.email
        };

        const user = _.pick(this.state, 'firstName', 'lastName', 'title', 'email', 'password');
        _.extend(user, {
            secureRoles: ['ReceiverDocumentPrimary', 'SiteAdminReceiver'],
            phoneNumber: this.state.phone
        });

        this.props.addNewUser(user)
            .then((response) => {
                const userResp = response.payload;
                if (userResp && userResp.data && userResp.data.id) {
                    return Promise.all([userResp, this.props.addNewMember(member)]);
                }
                if(typeof userResp === 'object' && userResp.constructor.name === 'Error') {
                    throw userResp;
                }
                throw new Error("Failed to create user.");
            })
            .then(results => {
                if (results[1] && results[1].payload && results[1].payload.data.errorResponse) {
                    throw new Error("Failed to create member.");
                }

                let userData = results[0].data;
                let memberData = results[1].payload.data.member;

                let memberAdmin = {
                    individualId: userData.id,
                    membrfk: memberData.id,
                    isPrimary: 'Y',
                    title: userData.title,
                    membrType: 'RIADMIN'
                };

                return Promise.all([results[0], this.props.addNewMemberAdmin(memberAdmin)]);
            })
            .then(results => {
                let userData = results[0].data;
                return Promise.all([results[0], this.props.verifyUser(_.pick(userData, 'individualEmailId'))]);
            })
            .then(results => {
                return Promise.all([results[0], this.props.authenticateNewUser(user.email, user.password, this.props.params.memberId)]);
            })
            .then(() => {
                this.props.router.push(`/u/registration/${this.props.params.memberId}/institution/confirm`);
            })
            .catch(err => {
                var errorMessage = 'Failed to create a parchment account, please try again';
                try {
                    if (err.response.data.errors[0]) {
                        errorMessage = 'Failed to create a parchment account. ' + err.response.data.errors[0];
                    }
                } catch (error) {}
                this.setState({ errorMessage });
                this.topOfForm.scrollIntoView();
            });
    }

    handleConsentFileDownload() {
        downloadBundledFile(require('file-loader?name=[path][name].[ext]!../media/credential_request_authorization_form.pdf'), 'credential_request_authorization_form.pdf');
    }

    handleEnterForToggleSignIn(e) {
        if(e.key === 'Enter') {
            this.toggleSignIn();
        }
    }

    toggleSignIn() {
        this.setState({showLogin: !this.state.showLogin});
    }

    renderErrorMessage() {
        if(this.state.errorMessage) {
            return (<NotificationBanner className="error"
                                        icon={<AiWarning aria-label="Error" />}
                                        closeButton
                                        onClose={() => this.setState({errorMessage: undefined})}
                                        ariaLive="assertive">
                {this.state.errorMessage}
            </NotificationBanner>);
        }
    }

    renderSignUpForm() {
        const formData = this.state;
        let token = getToken('address-verification-api');
        let addressProps = _.pick(formData, 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone');
        addressProps = _.extend(addressProps, {
            collectPhone: true,
            errorMessage: 'This is a required field.',
            addressValidation: {
                autocomplete: autoComplete(token, ADDRESS_VERIFICATION_BASE_URL),
                validate: validate(token, ADDRESS_VERIFICATION_BASE_URL)
            }
        });
        const validationProps = (name, required, value, errorMessage) => {
            let defaultErrorMessage = 'This is a required field.';
            if (required && !value) {
                errorMessage = defaultErrorMessage;
            }
            return {
                required: required,
                labelAsPlaceHolder: true,
                valid: this.props.isValid(name),
                value: value,
                errorMessage: errorMessage ? errorMessage : defaultErrorMessage,
                onBlur: this.props.handleValidation(name),
                onChange: _.partial(this.setFormValue, name)
            };
        };
        return (<Form autoComplete="off"><Section additionalClasses="default wildSand tpo-institution-page-top-container" shadow="top">
            <div className="row white rounded-border normal-padding xxLarge-margin-bottom medium-margin-top">
                <div className="inline">Already have a Parchment account?</div>
                <div className="inline sign-in-link" onClick={this.toggleSignIn} onKeyUp={this.handleEnterForToggleSignIn} role="link" tabIndex="0">Sign In here</div>
            </div>
            <h4 className="text-center medium-margin-bottom" ref={ref => this.topOfForm = ref}>Before getting started, here's what you'll need to complete your order.</h4>
            <div className="row xLarge-padding-bottom">
                <div className="col-sm-6 text-center info-group border-right">
                    <div className="info-icon"><AiIndividual1 viewBox="6 0 50 50"/></div>
                    <div className="info-icon-label small-padding-bottom">Learner Information</div>
                    <div className="info-label">You will be asked for information about the learner such as full name, other names used while attending school, DOB, and student ID. Please have this info handy.</div>
                </div>
                <div className="col-sm-6 text-center info-group">
                    <div className="info-icon"><AiVerified viewBox="6 0 50 50"/></div>
                    <div className="info-icon-label large-padding-bottom">Learner Consent</div>
                    <div><a href="javascript:void(1)" className="small" onClick={this.handleConsentFileDownload}><AiDownload3 />Download Learner Consent form</a></div>
                </div>
            </div>
            {this.renderErrorMessage()}
            <div className="row">
                <h5 className="bold">ENTER YOUR PERSONAL INFORMATION <span className="pull-right color-boulder italic">Learner information is collected later.</span></h5>
                <InputGrid>
                    <InputRow>
                        <InputField name="firstName" label="First Name" type="text" className="col-xs-6"
                                    {...validationProps('firstName', true, formData.firstName)} />
                        <InputField name="lastName" label="Last Name" type="text" className="col-xs-6"
                                    {...validationProps('lastName', true, formData.lastName)} />
                    </InputRow>
                    <InputRow>
                        <InputField name="memberName" label="Organization / School Name" type="text" className="col-xs-12"
                                    {...validationProps('memberName', true, formData.memberName)} />
                    </InputRow>
                    {/*<InputRow>*/}
                    {/*<InputField name="industrySegment" label="Industry / Market Segment" type="text" className="col-xs-12" {...validationProps('lastName', true)} />*/}
                    {/*</InputRow>*/}
                    <InputRow>
                        <InputField name="riType" label="Organization Type" type="select" className="col-xs-6"
                                    values={RI_TYPES}
                                    {...validationProps('riType', true, formData.riType)} />
                        <InputField name="title" label="Role / Title (ex. School Counselor)" aria-label="Role / Title" aria-placeholder="Example: School Counselor" type="text" className="col-xs-6"
                                    {...validationProps('title', true, formData.title)} />
                    </InputRow>
                </InputGrid>
            </div>
            <br />
            <div className="row">
                <h5 className="bold">ENTER YOUR CONTACT INFORMATION</h5>
                <AddressGrid {...addressProps}
                             onChange={this.setFormValue}
                             onBlur={this.handleBlur}
                             isValid={(field) => this.props.isValid(field)} />
            </div>
            <br />
            <div className="row">
                <h5 className="bold">ACCOUNT INFORMATION</h5>
                <InputGrid>
                    <InputRow>
                        <InputField name="email" label="Email Address" type="text" className="col-xs-6"
                                    {...validationProps('email', true, formData.email, 'Invalid Email format')} />
                        <InputField name="retypeEmail" label="Retype Email Address" type="text" className="col-xs-6"
                                    {...validationProps('retypeEmail', true, formData.retypeEmail, 'Does not match Email Address.')} />
                    </InputRow>
                    <InputRow>
                        <InputField name="password" label="Password" type="password" className="col-xs-6"
                                    {...validationProps('password', true, formData.password)} />
                        <InputField name="retypePassword" label="Retype Password" type="password" className="col-xs-6"
                                    {...validationProps('retypePassword', true, formData.retypePassword, 'Does not match Password.')} />
                    </InputRow>
                </InputGrid>
            </div>
            <br />
            <div className="row">
                <ContinueButton className="large-padding-top" onClick={this.onSubmit} enabled={!this.state.errors && this.state.isValid && this.props.isValid()} />
            </div>
        </Section></Form>);
    }

    render() {
        return (
            <div>
                {
                    !this.state.showLogin ?
                        this.renderSignUpForm() :
                        <LoginPage params={this.props.params} router={this.props.router}/>
                }
                <Section additionalClasses="default mercury tpo-institution-page-footer-container" shadow="top">
                    <div className="row">
                        <div className="col-sm-12">
                            {
                                !this.state.showLogin ?
                                    <div>Already have an account? <span className="sign-in-link" onClick={this.toggleSignIn} onKeyUp={this.handleEnterForToggleSignIn} role="link" tabIndex="0">log in</span>.</div> :
                                    <div>Don't have an account? <span className="sign-in-link" onClick={this.toggleSignIn} onKeyUp={this.handleEnterForToggleSignIn} role="link" tabIndex="0">Sign Up here</span>.</div>
                            }
                            <div>By signing up you agree to the Parchment <a href="https://www.parchment.com/terms-of-use">terms of use</a> and <a href="https://www.parchment.com/privacy-policy">privacy policy</a>.</div>
                        </div>
                    </div>
                </Section>
            </div>
        );
    }
}

export default validation(strategy)(InstitutionPage);
